import type { IUserContext } from '@sections/auth/context'
import { UserContext } from '@sections/auth/context'
import { useContext } from 'react'

function useUser(): IUserContext {
  const user = useContext(UserContext)
  return user
}

export default useUser
